import 'whatwg-fetch'
import { fetchAPI } from '../utils/request';
// @ts-ignore
import { Account_Data_Fields } from '@/constants/index'

// 用户相关接口
export const fetchUserInfo = () => {
   return fetchAPI('/user/info')
}

export const fetchUserPerm = () => {
  return fetchAPI('/user/get-perms')
}

export const modifyUserInfo = (payload: object) => {
  return fetchAPI('/user/edit', payload, 'POST')
}

export const authUser = (payload: object) => {
  return fetchAPI('/user/auth', payload, 'POST')
}

export const validateParams = (payload: object) => {
  return fetchAPI('/user/validate-params', payload, 'POST')
}

export const registerUser = (payload: object) => {
  return fetchAPI('/user/register', payload, 'POST')
}
// 自助忘记密码校验信息
export const checkInfo = (payload: object) => {
  return fetchAPI('/user/check-forget', payload, 'POST')
}
// 自助忘记密码,密码二次确认
export const passwordSecond = (payload: object) => {
  return fetchAPI('/user/reset-password', payload, 'POST')
}

export const userLogout = (payload: object) => {
  return fetchAPI('/user/logout', payload)
}

// 报表接口
export const fetchReportList = (payload: object) => {
  return fetchAPI('/report/list', payload)
}

export const addDownloadRequest = (payload: object) => {
  return fetchAPI('/download/request/add', payload, 'POST')
}

export const queryDownloadRequestStatus = (payload: object) => {
  return fetchAPI('/download/request/status', payload)
}

export const fetchDownloadRequest = (payload: object) => {
  return fetchAPI('/download/request/fetch', payload)
}

// 代理监控相关接口
export const fetchOperationLogs = (payload: object) => {
  return fetchAPI('/data/adv-operation-log/list', payload)
}

// 账户绑定相关接口
export const fetchBindList = (payload: object) => {
  return fetchAPI('/account/bind-list', payload)
}

export const unbindAccount = (payload: object) => {
  return fetchAPI('/account/unbind', payload, 'POST')
}

export const fetchAccountList = (payload: object) => {
  return fetchAPI('/account/search', payload)
}

export const bindAccount = (payload: object) => {
  return fetchAPI('/account/bind', payload, 'POST')
}

export const editRemark = (payload: object) => {
  return fetchAPI('/account/edit-remarks', payload, 'POST')
}

export const fetchBindLog = (payload: object) => {
  return fetchAPI('/account/bind-log', payload)
}

// 认证中心相关接口
export const fetchAuthInfo = (payload: object) => {
  return fetchAPI('/customer/detail', payload)
}

export const modifyAuthInfo = (payload: object) => {
  return fetchAPI('/customer/edit', payload, 'POST')
}

export const addAuthInfo = (payload: object) => {
  return fetchAPI('/customer/add', payload, 'POST')
}

export const fetchAuthList = (payload: object) => {
  return fetchAPI('/customer/list', payload)
}

export const auditAuth = (payload: object) => {
  return fetchAPI('/customer/audit', payload, 'POST')
}

// 消息相关接口
export const fetchMessageList = (payload: object) => {
  return fetchAPI('/message/list', payload)
}

export const readMessage = (payload: object) => {
  return fetchAPI('/message/read', payload, 'POST')
}

// 模拟登录adv
export const advLogin = (payload: object) => {
  return fetchAPI('/report/adv/login', payload, 'POST')
}

// 首页相关接口
export const fetchSummaryData = (payload: object) => {
  return fetchAPI('/data/dashboard/summary', payload)
}
export const fetchCostData = (payload: object) => {
  return fetchAPI('/data/dashboard/cost-pie', payload)
}
export const fetchOperationData = (payload: object) => {
  return fetchAPI('/data/adv-operation-log/statistics', payload)
}
export const fetchDailyData = (payload: object) => {
  return fetchAPI('/data/dashboard/daily-line', payload)
}
// 白名单接口
export const fetchWhiteList = (payload: object) => {
  return fetchAPI('/white-list/list', payload)
}

export const addWhiteList = (payload: object) => {
  return fetchAPI('/white-list/add', payload, 'POST')
}

// 素材库相关接口
export const fetchAllBindList = (payload: object) => {
  return fetchAPI('/account/get-all-bind-list', payload)
}

export const fetchRecoVideoList = (payload: object) => {
  return fetchAPI('/resource/recommend-list', payload)
}

export const shareRecommend = (payload: object) => {
  return fetchAPI('/resource/batch-share-recommend', payload, 'POST')
}

export const fetchVideoDepoList = (payload: object) => {
  return fetchAPI('/resource/library-list', payload)
}

export const shareVideoDepo = (payload: object) => {
  return fetchAPI('/resource/batch-share-library', payload, 'POST')
}

// 授权管理相关接口

export const fetchAuthManageList = (payload: object) => {
  return fetchAPI('/mkt/auth/list', payload)
}

export const acceptAuth = (payload: object) => {
  return fetchAPI('/mkt/auth/accept', payload, 'POST')
}

export const rejectAuth = (payload: object) => {
  return fetchAPI('/mkt/auth/refuse', payload, 'POST')
}

export const cancelAuth = (payload: object) => {
  return fetchAPI('/mkt/auth/cancel', payload, 'POST')
}

export async function getAccountDataColumn(params: any = {}) {
  return Promise.resolve(Account_Data_Fields)
  return fetchAPI(`/reports/dimension/filter/items`, params)
}


// WEBPACK FOOTER //
// ./src/services/index.tsx